import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';


export const authGuard: CanActivateFn = () => {
 const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
    const storageService = inject(StorageService);


  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const token = storageService.get('Login-SID');

  if (token) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
